module.exports = "/_next/static/images/pwa-21e9af4af6c1ae49574cdfcdc7bd536e.png";